import { NgTemplateOutlet } from "@angular/common";
import {
    ChangeDetectionStrategy,
    Component,
    computed,
    contentChildren,
    signal,
    ViewEncapsulation,
} from "@angular/core";
import { CerrixTabDirective } from "./cerrix-tab.directive";

@Component({
    selector: "app-cerrix-tabs",
    imports: [NgTemplateOutlet],
    templateUrl: "./cerrix-tabs.component.html",
    styleUrl: "./cerrix-tabs.component.scss",
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CerrixTabsComponent {
    // The default query depth is enough: a tab the caller wraps in an @if is still found
    // (covered by the spec), and staying shallow keeps a nested tabs container's tabs out.
    protected readonly tabs = contentChildren(CerrixTabDirective);

    protected readonly panelId = `cerrix-tab-panel-${crypto.randomUUID()}`;

    private readonly selected = signal<CerrixTabDirective | undefined>(undefined);

    // Falls back to the first tab, so a caller removing the selected tab cannot leave an empty body.
    protected readonly activeTab = computed(() => {
        const tabs = this.tabs();
        const selected = this.selected();

        return selected && tabs.includes(selected) ? selected : tabs[0];
    });

    protected select(tab: CerrixTabDirective): void {
        this.selected.set(tab);
    }
}
